<div class="glxy-sublist" [ngClass]="{ open: expanded, 'in-container': isInContainer, disabled }">
  <button
    aria-controls="#content"
    [attr.aria-expanded]="expanded"
    aria-describedby="#label"
    class="glxy-sublist-label"
    [class.open]="expanded"
    [class.disabled]="disabled"
    (click)="toggle()"
    [disabled]="disabled"
  >
    <div class="glxy-sublist-label-content">
      <ng-content select="[glxy-sublist-label]" />
      <ng-container [ngTemplateOutlet]="label" />
    </div>
    <span class="material-icons glxy-sublist-chevron" [ngClass]="{ open: expanded, disabled }" aria-hidden="true">{{
      designVersion() === 'legacy' ? 'arrow_right' : 'expand_more'
    }}</span>
  </button>

  <div
    #content
    class="glxy-sublist-content"
    [@openClose]="expanded ? 'open' : 'closed'"
    [style.visibility]="expanded ? 'visible' : 'hidden'"
    role="region"
  >
    <ng-content select="glxy-sublist-content, [glxy-sublist-content], [glxySublistContent]" />
  </div>
</div>

<ng-template #label><ng-content /></ng-template>
